import React, { useState, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import LabelMessage from './LabelMessage';
import './CustomCaptcha.scss';

interface ReCAPTCHAProps {
    onVerify: (verified: boolean, token: string) => void;
    useCache:boolean
}

const sitekey = "6LdQlQ0pAAAAADjbxloDIchjMWSdfO5H3l6Lnvzi";
const hl = 'es';

const CustomReCAPTCHA: React.FC<ReCAPTCHAProps> = ({ onVerify,useCache }) => {
    const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
    const [showCaptcha, setShowCaptcha] = useState(true);

    useEffect(() => {
        // Check if captcha was already verified in this session
        const captchaVerified = useCache?sessionStorage.getItem('captchaVerified'):null;
        var expirationTime=useCache?sessionStorage.getItem('captchaExpiration'):null;
        if (captchaVerified === 'true'&&expirationTime!=null) {
            if (Date.now() < Number(expirationTime)) {
                setIsCaptchaVerified(true);
                setShowCaptcha(false);
                onVerify(true, ''); // Notify parent that captcha is already verified
            }else{
                setShowCaptcha(true);
                sessionStorage.removeItem('captchaVerified');
                sessionStorage.removeItem('captchaExpiration');// Save verification in session
            }
        }else
            setShowCaptcha(true);
    }, [onVerify]);

    const handleCaptchaChange = (value: string | null) => {
        if (value) {
            setIsCaptchaVerified(true);
            if(useCache){
                const expirationTime = Date.now() + 90 * 60 * 1000; // 90 minutes in milliseconds
                sessionStorage.setItem('captchaVerified', 'true');
                sessionStorage.setItem('captchaExpiration', expirationTime+"");// Save verification in session
            }
            onVerify(true, value);
        }
    };

    return (
        <div className='recatpcha'>
            {showCaptcha && (
                <ReCAPTCHA sitekey={sitekey} hl={hl} onChange={handleCaptchaChange} />
            )}
            {!isCaptchaVerified && (
                <div className='messageLabel'>
                    <LabelMessage valid={isCaptchaVerified} message="Por favor, verifica el captcha antes de continuar" />
                </div>
            )}
        </div>
    );
};

export default CustomReCAPTCHA;